import AdminSisSyncConnectedView from './AdminSisSyncConnectedView';

export default AdminSisSyncConnectedView;
